import React, { useState, useEffect } from "react";
import AccountTable from "./AccountTable";
import useAuthStore from "../../../../store/useAuthStore";

const AssetsAccount = ({ refreshTrigger, onAddSuccess }) => {
  const [accounts, setAccounts] = useState([]); // Holds filtered accounts
  const { token } = useAuthStore();

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await fetch("/api/getAllAccounts", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const result = await response.json();

          // Filter accounts for types 'Current Asset' and 'Non-current Asset'
          const filteredAccounts = result.accounts.filter(
            (account) =>
              account.type === "Current Asset" ||
              account.type === "Non-current Asset"
          );

          setAccounts(filteredAccounts);
        } else {
          const errorData = await response.json();
          console.error(errorData.error || "Failed to fetch accounts");
        }
      } catch (error) {
        console.error("Error fetching accounts:", error);
      }
    };

    fetchAccounts();
  }, [token, refreshTrigger]); // Dependency ensures it refetches if the token or refreshTrigger changes

  const handleDelete = (updatedRows) => {
    setAccounts(updatedRows);
    console.log("Accounts after deletion:", updatedRows);
  };

  return (
    <AccountTable
      rows={accounts}
      title="Assets Accounts"
      onAddSuccess={onAddSuccess}
      actions={[
        {
          label: "Delete",
          onClick: () => handleDelete(accounts.filter((row) => row.isSelected)),
          className: "bg-red-500 text-white hover:bg-red-600",
        },
      ]}
    />
  );
};

export default AssetsAccount;
